import TransactionsTable from './TransactionsTable'

export default TransactionsTable
